'use strict';

var renderTasks = require('./renderTasks');
var updateProgressBar = require('./updateProgressBar');
var renderFilter = require('./renderFilter');
var renderTasksDone = require('./renderTasksDone');
var toggleTasks = require('./toggleTasks');
var bindEvents = require('./marketingChecklistBindEvents');
var addTopPrioritiesLabelText = require('./addTopPrioritiesLabelText');

function renderMarketingTasks (mustaches, tasksJson, isAdvancedReview) {
  var $marketingChecklist = $('.marketing-checklist');
  var tasks;
  var tasksDone;

  tasksJson.isAdvancedReview = isAdvancedReview;

  if (isAdvancedReview) {
    updateProgressBar($('#dashboard-tasks-bars'), tasksJson.stats);
    updateProgressBar(
      $marketingChecklist.find('.progress-container'), tasksJson.stats
    );

    renderFilter(
      mustaches.marketingTasksFilter,
      $marketingChecklist,
      tasksJson.categories
    );

    tasks = tasksJson.tasksList.reduce(function (result, task) {
      task.isAdvancedReview = isAdvancedReview;
      task.done = task.checked || task.autochecked;
      result.push(task);
      return result;
    }, []);

    tasksDone = tasks.filter(function (task) {
      return task.done;
    });

    if (tasksDone.length) {
      renderTasksDone($marketingChecklist, tasksDone);
    }
  } else {
    $marketingChecklist.find('.show-links').addClass('hidden');
    tasks = tasksJson.tasksList;

    tasks.forEach(function (task, i) {
      tasks[i].quickTipCriterium = null;
    });

    if (tasks.length >= 3) {
      $marketingChecklist.find('.show-links').removeClass('hidden');
    }
  }

  if (tasks.length > 0) {
    renderTasks(mustaches.marketingTasks, $marketingChecklist, tasks);
  } else {
    $marketingChecklist.find('.marketing-checklist-list-alldone').removeClass('hidden');
    $marketingChecklist.find('.loader').addClass('hidden');
  }

  bindEvents(isAdvancedReview);
  addTopPrioritiesLabelText($marketingChecklist);

  if (isAdvancedReview) {
    toggleTasks($marketingChecklist);
  }
  return $(window).trigger('projectTasksLoaded');
}

module.exports = renderMarketingTasks;
